(function () {
    'use strict';

    angular.module('ib-basket-module', [
        'ib-trips-module',
        'ib-ancillaries-baggages-module',
        'ib-ancillaries-speqs-module',
        'ib-ancillaries-seats-module',
        'ib-ancillaries-insurances-module',
        'ib-ancillaries-allianz-fusion-insurances-module',
        'ib-ancillaries-upgrading-module',
        'ib-ancillaries-carbon-footprint-module',
        'ib-ancillaries-transfers-globick-module',
        'ib-ancillaries-activities-globick-module',
        'ib-others-fees-module',
        'ib-basket-section',
        'ib-ancillaries-priority-module',
        'ib-ancillaries-bundle-module'
    ]);
})();
